<app-header *ngIf="!isPublicLanding"></app-header>

<div class="loader-container" *ngIf="(loading$ | async) && !isPublicLanding">
<!--  <div class="loader"></div>-->
  <div class="logo-loader h-100 w-100 z-3 flex align-items-center justify-content-center">
    <div class="smart">Smart</div>
    <div class="dukaan">Dukaan</div>
    <div class="loader-animation"></div>
  </div>
</div>

<div class="app-body">
  <router-outlet></router-outlet>
</div>

<app-footer *ngIf="!isPublicLanding"></app-footer>
